export const iconFontAwesomeDesignCube = (
	<i className="fa-solid fa-cube"></i>
);
